/*
 * @Author: your name
 * @Date: 2021-08-06 14:14:22
 * @LastEditTime: 2021-08-12 20:42:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-bi-project-wrap-h5/src/store/UserData/userData.ts
 */
import { observable, action } from 'mobx';
import { getCookie } from '@/utils/utils'
type userDataType = {
    userName?: string,
    roleType?: string | number
}
class UserData {
    @observable public userData: userDataType = {
        userName: getCookie('userName')
    };
    @action
    public changeUserData = (userData: userDataType) => {
        this.userData = userData
    }
}
export { UserData, userDataType }
export default new UserData()
